import React, { useState } from 'react';

export default function SchoolLoginDesign4() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-green-100">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-600 to-teal-600 px-8 py-16 text-center">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg">
                <span className="text-4xl">🌱</span>
              </div>
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">SMART SCHOOL</h1>
            <p className="text-green-100">Educational Excellence Platform</p>
          </div>

          {/* Form */}
          <div className="px-8 py-12 space-y-6">
            <div>
              <label className="block text-sm font-bold text-gray-800 mb-3">Email</label>
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="user@smartschool.edu"
                  className="w-full px-4 py-3 border-2 border-green-200 rounded-xl focus:outline-none focus:border-green-600 focus:ring-2 focus:ring-green-200 transition bg-green-50"
                />
                <span className="absolute right-4 top-3 text-xl">📧</span>
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-800 mb-3">Password</label>
              <div className="relative">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full px-4 py-3 border-2 border-green-200 rounded-xl focus:outline-none focus:border-green-600 focus:ring-2 focus:ring-green-200 transition bg-green-50"
                />
                <span className="absolute right-4 top-3 text-xl">🔐</span>
              </div>
            </div>

            <div className="flex items-center justify-between pt-2">
              <label className="flex items-center gap-2 text-sm text-gray-700">
                <input type="checkbox" className="w-4 h-4 rounded text-green-600 border-green-300" />
                <span>Stay logged in</span>
              </label>
              <a href="#" className="text-sm text-green-600 hover:text-green-700 font-bold">Reset Password</a>
            </div>

            <button className="w-full bg-gradient-to-r from-green-600 to-teal-600 text-white font-bold py-3 rounded-xl hover:shadow-lg transition duration-300 transform hover:scale-105">
              Login to Account
            </button>

            <div className="text-center">
              <p className="text-gray-600 text-sm">
                New to Smart School?{' '}
                <span className="text-green-600 font-bold cursor-pointer hover:text-green-700">Register Here</span>
              </p>
            </div>

            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="text-xs text-green-700 text-center font-semibold">
                ✓ Secure • ✓ Verified • ✓ Trusted by 500+ Schools
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gradient-to-r from-green-50 to-teal-50 px-8 py-4 border-t border-green-100">
            <p className="text-xs text-gray-600 text-center">Smart School Management © 2024</p>
          </div>
        </div>
      </div>
    </div>
  );
}
